import { isRouteErrorResponse, useRouteError } from '@/shared/modern-router';

const ErrorBoundary = () => {
  const error = useRouteError();

  if (isRouteErrorResponse(error)) {
    return (
      <h1>
        {error.status} {error.statusText}
      </h1>
    );
  }

  return <h1>{error instanceof Error ? error.message : null}</h1>;
};

ErrorBoundary.displayName = 'HrisOrgChartExplorer.ErrorBoundary';

export default ErrorBoundary;
